const leftMenuContentReducer = (state = "", action) => {
    switch (action.type) {
      case "SET_LEFT_MENU_CONTENT":
        return action.payload;
      default:
        return state;
    }
  }
  export default leftMenuContentReducer;